import "bootstrap-icons/font/bootstrap-icons.css";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../redux/SettingAction";

export const VipHome = ({ setSwalProps }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const settingState = useSelector(({ setting }) => setting, shallowEqual);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "#ffffff", // white font for legend
        },
      },
      title: {
        display: true,
        text: intl.formatMessage({ id: "commission" }),
        color: "#ffffff", // white title
      },
      tooltip: {
        backgroundColor: "#333",
        titleColor: "#fff",
        bodyColor: "#fff",
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff", // white font for x-axis labels
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)", // light grid lines
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#ffffff", // white font for y-axis labels
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)",
        },
      },
    },
  };

  useEffect(() => {
    dispatch(actions.getVipList());
  }, []);

  const onClaim = () => {
    dispatch(actions.claimVipComm()).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === 0) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "claimSuccessfully" }),
          onResolve: () => {
            setSwalProps({});
            dispatch(actions.getVipList());
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <div>
      {settingState.vipList ? (
        <div>
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div
              className="p-1 rounded col-3"
              style={{ backgroundColor: "#1c1e23" }}
            >
              <div className="text-center">
                {intl.formatMessage({ id: "downline" })}
              </div>
              <div className="text-center">
                {settingState.vipList.downlinecount}
              </div>
            </div>
            <div
              className={`rounded col-4 ${
                parseFloat(settingState.vipList.vipbalance ?? "0") >= 1
                  ? "pt-1"
                  : "p-1"
              }`}
              style={{ backgroundColor: "#1c1e23" }}
            >
              <div className="text-center">
                {intl.formatMessage({ id: "availableBalance" })}
              </div>
              <div className="text-center">
                {settingState.vipList.vipbalance}
              </div>
              {parseFloat(settingState.vipList.vipbalance ?? "0") >= 1 && (
                <div
                  className="text-center p-1 rounded-bottom text-dark fw-bold"
                  style={{ background: "#ffa500" }}
                  onClick={onClaim}
                >
                  {intl.formatMessage({ id: "claim" })}
                </div>
              )}
            </div>
            <div
              className="p-1 rounded col-3"
              style={{ backgroundColor: "#1c1e23" }}
            >
              <div className="text-center">
                {intl.formatMessage({ id: "commission" })}
              </div>
              <div className="text-center">
                {settingState.vipList.totalcommission}
              </div>
            </div>
          </div>
          <div
            className="rounded p-2 mb-2"
            style={{
              backgroundColor: "#1c1e23",
            }}
          >
            <Bar
              data={{
                labels: settingState.vipList.memberVipComms.map(
                  (item) => item.transdate
                ),
                datasets: [
                  {
                    label: intl.formatMessage({ id: "commission" }),
                    data: settingState.vipList.memberVipComms.map((item) =>
                      parseFloat(item.commission)
                    ),
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    borderRadius: 5,
                  },
                ],
              }}
              options={options}
            />
          </div>
          <div
            className="rounded p-2 mb-2"
            style={{
              backgroundColor: "#1c1e23",
            }}
          >
            <div className="text-center fw-semibold mb-2">
              {intl.formatMessage({ id: "newMembers" })}
            </div>
            {settingState.vipList.memberVipNewMember.length > 0 ? (
              <div className="d-flex flex-column gap-2">
                {settingState.vipList.memberVipNewMember.map(
                  (memberVipNewMember) => (
                    <div
                      key={memberVipNewMember.memberid}
                      className="rounded p-2 shadow-lg"
                      style={{ background: "#323438" }}
                    >
                      <div className="mb-3 fw-semibold">
                        {memberVipNewMember.username}
                      </div>
                      <div
                        className="d-flex justify-content-between align-items-center "
                        style={{ fontSize: "11px" }}
                      >
                        <div>
                          {intl.formatMessage({ id: "inviteBy" })} :{" "}
                          {memberVipNewMember.invitebyusername}
                        </div>
                        <div>
                          {intl.formatMessage({ id: "regDate" })} :{" "}
                          {memberVipNewMember.regdate}
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            ) : (
              <div
                className="text-font3"
                style={{
                  color: "white",
                  textAlign: "center",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                }}
              >
                {intl.formatMessage({ id: "noRecordFound" })}
              </div>
            )}
          </div>
        </div>
      ) : (
        <Skeleton className="w-100" height="600px" />
      )}
    </div>
  );
};
